import React from "react";
import Helmet from "react-helmet";

const HelmetWrapper = (props) => (
    <Helmet defaultTitle="Wat?" titleTemplate="%s | Demo" {...props} />
);

HelmetWrapper.displayName = 'Helmet';

export default HelmetWrapper;